export const AMAZON_QUERY_PARAMS = {
    SESSION_ID: "amazonCheckoutSessionId",
    ACTION: "amz-action",
};

export const AMAZON_ACTIONS = {
    // User cancelled the checkout process
    CANCEL: "cancel",
    // Unknown error in checkout
    ERROR: "error",
};

export const AMAZON_PAY_KEY_CONFIG = {
    publicKeyId: process.env.NEXT_PUBLIC_AMAZON_PAY_PUBLIC_KEY,
    // Private key contains newline characters, which on Mac will be loaded as "\\n" instead of "\n". This causes private key validation to fail.
    privateKey: process.env.AMAZON_PAY_PRIVATE_KEY?.replace(/\\n/g, "\n"),
    algorithm: "AMZN-PAY-RSASSA-PSS-V2",
};
